module.exports = __webpack_public_path__ + "img/Foto_ElektroInstall-JB-4545_2019.4866a1d2.jpg";